export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LfcyVEtAAAAADai8tHGICBOUXuLIwM126Q7ihFG',
  },

  /*baseUrl: 'https://syndicatesettlementclai-development-byasfma4chefbahw.centralus-01.azurewebsites.net/api/'*/
  baseUrl: 'https://syndicatesettlementclaimform-hjeje6aab3cbb6fr.centralus-01.azurewebsites.net/api/'

  /* baseUrl: 'https://localhost:7249/api/'*/
};

